import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesCXP() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: null, items: [
      { label: "Compras", icon: "fas fa-money-check-alt", color: "#3b82f6", href: "/ListadoComprasCXP", desc: "Compras por pagar", enabled: !!user.edoCtaProveedores },
      { label: "Abonos", icon: "fas fa-dollar-sign", color: "#10b981", href: "/ListadoAbonosProveedores", desc: "Pagos a proveedores", enabled: !!user.pagoProveedores },
      { label: "Estado de Cuenta", icon: "fas fa-file-invoice-dollar", color: "#6366f1", href: "/EstadoCuentaCXP", desc: "Saldos por proveedor", enabled: !!user.edoCtaProveedores },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Cuentas por Pagar"
      descripcion="Saldos y pagos a proveedores"
      icono="fas fa-file-invoice"
      color="#ef4444"
      secciones={SECCIONES}
    />
  );
}

export default BotonesCXP;
